// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"24383":"503166ac1f48a1c2","43074":"ca766e9d030f506b"}[chunkId] + ".css";
};